export default {
  app: {
    title: 'ZR Markets 用户中心',
    brand: 'ZR Markets',
    portal: '投资者门户',
  },

  common: {
    confirm: '确定',
    cancel: '取消',
    later: '稍后',
    close: '关闭',
    submit: '提交',
    save: '保存',
    edit: '修改',
    back: '返回',
    next: '下一步',
    prev: '上一题',
    retry: '重试',
    refresh: '刷新',
    copy: '复制',
    copied: '已复制 ✓',
    copyFailed: '复制失败，请手动复制',
    loading: '加载中…',
    today: '今天',
    clear: '清除',
    pickYearMonth: '选择年份与月份',
    empty: '暂无数据',
    required: '必填',
    optional: '选填',
    all: '全部',
    status: '状态',
    amount: '金额',
    currency: '币种',
    account: '交易账户',
    manage: '管理',
    contactSupport: '联系客服',
    emailSent: '已发邮件',
    loadFailed: '加载失败，请稍后重试',
    networkError: '网络异常，请稍后重试',
    notAvailableYet: '该功能的后端接口尚未提供，暂不可用。',
  },

  nav: {
    companyInfo: '公司信息',
    companyPeople: '人员认证与文件',
    // §4.1 菜单命名以需求表为准，中英一一对应
    overview: '概览',
    overviewBeforeOnboarding: '开户',
    accounts: '账户管理',
    myAccount: '我的账户',
    profile: '个人资料',
    funding: '资金管理',
    deposit: '入金',
    withdraw: '出金',
    bankAccounts: '银行账号',
    reports: '报表',
    depositRecords: '存款记录',
    withdrawalRecords: '取款记录',
    platform: '平台下载',
    support: '帮助与支持',
    logout: '退出登录',
    menu: '菜单',
    notReady: '接口未提供',
  },

  auth: {
    // 登录页左半屏品牌区（与开户站注册页同一套文案）
    brand: {
      title: '澳大利亚 ASIC 监管',
      licence: 'AFSL 562700',
      segregated: '客户资金独立存管。',
      f0: 'ASIC 监管 AFSL 562700',
      f1: 'MetaTrader 5 专业平台',
      f2: '注册即开通模拟账户',
    },
    loginTitle: '登录用户中心',
    email: '邮箱地址',
    password: '登录密码',
    remember: '在此设备上保持登录',
    forgot: '忘记密码？',
    login: '登录',
    noAccount: '还没有账户？',
    openAccount: '立即开户',
    // 不区分账号不存在 / 密码错误，防枚举（§5.1）
    badCredentials: '邮箱或密码不正确',
    emailInvalid: '请输入有效的邮箱地址',
    passwordRequired: '请输入登录密码',
    loggingIn: '正在登录…',

    forgotTitle: '重置登录密码',
    forgotDesc: '请输入您的注册邮箱，我们会向该邮箱发送重置链接。',
    sendLink: '发送重置链接',
    // 统一提示，不暴露邮箱是否存在（§5.2）
    forgotSent: '若该邮箱已注册，重置链接已发送。',
    forgotSentHint: '重置链接 30 分钟内有效。请检查收件箱与垃圾邮件文件夹。',
    backToLogin: '返回登录',

    resetTitle: '设置新密码',
    newPassword: '新密码',
    confirmPassword: '确认新密码',
    mismatch: '两次输入的密码不一致',
    resetDone: '新密码已生效',
    resetDoneDesc: '确认邮件已发送；其他已登录设备已全部退出。',
    linkExpired: '该链接已失效',
    linkExpiredDesc: '重置链接仅 30 分钟内有效，请重新申请一封。',
    requestAgain: '重新申请',

    changeTitle: '修改登录密码',
    currentPassword: '当前密码',
    changeDone: '密码已更新，确认邮件已发送；其他已登录设备已全部退出。',

    ruleTitle: '密码需满足：',
    ruleLength: '8–20 位',
    ruleUpper: '至少 1 个大写字母',
    ruleLower: '至少 1 个小写字母',
    ruleDigit: '至少 1 个数字',
    ruleNotSame: '不能与当前密码相同',

    lockedTitle: '账户已临时锁定',

    // ---- 登录准入被拒（接口 0.10.0 / V1.4 §5.4）：三种拒绝三种去处 ----
    reviewPendingTitle: '您的开户申请正在审核中',
    reviewPendingDesc: '我们已收到您的开户申请，目前正在审核。审核期间暂时无法登录用户中心——这不是您的操作有误，也不需要重复尝试。',
    reviewPendingNext: '审核完成后我们会通过邮件通知您，届时即可正常登录。',
    reviewPendingContact: '如需了解进度，请联系客服：',
    denyApplicationDeclined: '很抱歉，您的开户申请未能通过，暂无法登录用户中心。如需了解详情，请联系客服 {email}。',
    denyPortalDisabled: '您的账户暂不可用，请联系客服。',
    clientTypeMissing: '登录信息不完整，请稍后重试；若反复出现请联系客服。',

    // ---- 首登强制改密（V1.4 §5.2）：与「密码已过期」同一个页面，文案不同 ----
    firstLoginTitle: '首次登录，请设置您的登录密码',
    firstLoginDesc: '您当前使用的是开通邮件里的初始密码。为了账户安全，请先设置一个只有您知道的新密码。',
    // 首登页没有「当前密码」栏，这一条本地无从判定，作为清单下方的一句说明呈现
    ruleNotSameInitial: '不能与初始密码相同',
  },

  /** 公司相关人士认证清单（V1.4 §6A） */
  kycPeople: {
    /* 二期 P05：已通过的人有在途的重新认证（客服按要求更正了身份资料） */
    reverifyRequested: '待用新证件认证',
    /* 重新认证进度（2026-10-15，后端给）：已提交 / 已通过待生效 / 未通过可重拍 / 终拒 */
    reverifySubmitted: '新证件审核中',
    reverifyPassed: '新证件已通过 · 待生效',
    reverifyRetry: '新证件未通过 · 请重拍',
    reverifyRejected: '新证件未通过 · 请联系客服',
    titlePre: '公司相关人士身份认证',
    titleOpened: '人员认证与文件',
    passedOf: '已通过 {passed} / {total}',
    selfTag: '本人',
    noContact: '未登记联系方式',
    /* 按钮文案按原型（V1.4 §6A 第 #5 条）：本人与其他人**同一句**「在此设备认证」。
       同一列里两种叫法（「现在认证」/「在此认证」）看着像两个不同功能 */
    verifyHere: '在此设备认证',
    reverifyHere: '在此设备重新认证',
    useMobile: '扫码用手机认证',
    sendLink: '发送认证链接',
    resendLink: '重发认证链接',
    sendReverifyLink: '发送重新认证链接',
    inviteSent: '认证链接已发送至 {masked}，7 天内有效；{name} 完成后本页状态将自动更新。',
    inviteSelfHint: '这是您本人，请直接点「在此设备认证」。',
    invitePassedHint: '该人员已完成认证，无需再发送。',
    inviteNoContact: '未登记联系方式，无法发送认证链接；请联系客服补充。',
    /* 需补件的两层解释（原型 §6A ④）：驳回原因由后端给，这两句是固定的「不必从头再来」 */
    resubmitSaved: '{name} 已提交的其他资料都已保存，只需用上面任一方式重新完成未通过的那一步。',
    resubmitNotifiedBoth: '原因与重新提交指引已发送至您的邮箱及该人邮箱。',
    resubmitNotifiedRep: '原因与重新提交指引已发送至您的邮箱。',
    reviewNote: '资料已提交，我们正在人工核对，无需重新提交；有结果会以邮件通知您。',
    /* 未通过是终态：三条自助入口都已关闭，只能由我们重新开放。不披露原因（与统一婉拒同口径） */
    failedNote: '该人员本次认证未能通过，需由我们协助处理后才能再次认证。请',
    /* 只陈述起点，不说「已提交/审核中」：有起点没结论有三种可能，我们分不清是哪一种 */
    startedAt: '已于 {time} (UTC) 发起认证',
    /* 返回清单后仍在等结论时的行内提示：只说我们在做的事，不替客户断言他提交没提交 */
    syncing: '正在检查最新状态…',
    /* 迁移遗留：这一档是我们缺字段，不是客户要办的事——说清楚并给客服入口，别让他去重认 */
    notCollectedNote: '该人员的证件有效期我们尚未登记，认证结果不受影响。如需补录，请',
    docsToggle: '认证与文件',
    docId: '身份证明',
    docPoa: '地址证明',
    docAml: 'AML 筛查',
    validUntil: '有效期至 {date}',
    nextUpdate: '下次更新 {date}',
    /* 二期 §14.7：地址证明是 Sumsub 独立的第三步 */
    poaVerified: '已验证',
    amlPassed: '已通过',
    daysLeft: '还剩 {n} 天，请在到期前重新认证',
    expiredNow: '请立即重新认证',
    docsNote:
      '根据我们的账户政策，身份证件须在到期前重新认证，地址证明按周期更新；到期前我们会提前提醒。身份证明与地址证明在同一次认证中采集；AML 筛查由系统自动完成，无需另行提交材料。',
    allPassed: '全部人员已通过身份认证。我们正在为公司开立 MT5 交易账户，完成后会以邮件通知您。',
    someFailed: '有人员的身份认证未通过，账户暂无法开立。如需了解详情，',
    empty: '暂无相关人士记录。如有疑问请联系客服。',
    /* 原型页脚的两句口径缺一不可：只有授权代表有登录账号，其余人靠这三条路（V1.4 §6A） */
    footPre:
      '用户中心仅授权代表可登录，公司相关人士不开设登录账号。每位人员须由本人完成证件拍摄与活体检测：可在此设备直接认证、用本人手机扫码认证，或通过发送到其邮箱的认证链接自行完成（7 天内有效，过期后可再次发送）。每位人员只需完成一次。',
    footOpened: '证件到期前 60 天我们会以邮件提醒；证件即将到期或已过期时，这里会出现重新认证入口。',
  },

  /** 认证前确认卡（V1.4 §6A） */
  kycConfirm: {
    title: '开始前，请核对以下资料',
    desc: '这些是我们为您登记的资料。请确认与您即将上传的证件一致。',
    reverifyDescPerson: '我们正按贵公司的要求更新 {name}（{role}）的身份资料。请使用新的证件完成这次认证（不要用旧证件），通过后经审核即更新。',
    descPerson: '这些是我们为 {name}（{role}）登记的资料。请确认与即将上传的证件一致。',
    name: '姓名',
    dob: '出生日期',
    address: '居住地址',
    idType: '证件类型',
    idNumber: '证件号',
    idExpiry: '证件有效期至',
    idCountry: '证件签发国',
    warn: '如与证件不一致，认证会转为人工审核并延长处理时间。资料有误请先联系客服更正，再开始认证。',
    proceed: '资料无误，继续',
  },

  /** 认证前预检页（零售，V1.4 §6A） */
  kycStart: {
    title: '开始身份认证',
    titleReverify: '重新认证',
    stepN: '第 {n} 步',
    // 原型 V1.4.1「认证内容」三步：证件拍摄 → 活体检测 → 地址证明
    step1: '证件拍摄：护照或驾照，按提示拍摄正反面',
    step2: '活体检测：短视频自拍，须由您本人完成',
    step3: '地址证明：3 个月内的银行对账单或水电账单',
    recordTitle: '我们登记的资料',
    name: '姓名',
    dob: '出生日期',
    address: '居住地址',
    country: '居住国家 / 地区',
    warn: '请确认以上资料与您即将上传的证件一致。不一致会转为人工审核并延长处理时间。',
    proceed: '资料无误，开始认证',
    mismatchHint: '资料有误？请先联系客服更正后再开始，认证过程中无法修改。',
    /* 二期 P05：敏感信息更正发起的重新认证——登记资料是旧值，不展示 */
    useNewId: '请使用新证件',
    proceedNewId: '用新证件开始认证',
    useNewIdDesc: '我们正按您的要求更新身份资料。请使用新的证件完成这次认证（不要用旧证件），通过后经审核即更新到您的账户。',
    // 恢复登录时客服要求重新提交（决策 029，D-98）：登记资料没在改，照常展示；不说「新证件」。文案待产品确认
    rekycTitle: '请按客服要求重新提交认证资料',
    rekycDesc: '客服已要求您重新完成身份认证（如身份证明、地址证明）。请先核对下方登记资料，再按指引拍摄上传，提交后我们会尽快审核。',
    /* 已提交待人工复核：这一档不给「开始认证」，后端此时也拒签 SDK token */
    underReview: '您的资料已提交，我们正在人工核对（通常 1 个工作日内），暂时不需要重新提交。结果会以邮件通知您。',
  },

  /** SDK 承载面板 */
  kycSdk: {
    verifying: '正在认证：{name}',
    selfTag: '本人',
    backToList: '返回清单',
    /* 合规提示：代表可以替他拉起 SDK，但拍摄与活体必须本人做（原型蓝条同款） */
    byPersonHint: '请确保由本人完成证件拍摄与活体检测。',
    byYouHint: '请由您本人完成证件拍摄与活体检测。',
    /*
     * 这里原来还有 stepLine / step1 / step2 / countryHint 四条，已删：
     * 步骤由 Sumsub 自己的界面显示（原型 P8 就是它的界面还原，步骤片在它的头部里），
     * 我们外面再写一个不但重复，而且那个 n 取自「SDK 起来没起来」，一进去就显示 2/2；
     * 「签发国默认为 X」更是我们没做的事（那个值从没传给 Sumsub）。
     */
    /**
     * 认证组件（第三方 SDK 脚本）没下载下来。与「认证通道准备中」不是一回事：
     * 那个是我们签不出 token，这个是浏览器取不到 SDK 脚本——该做的事不同，
     * 混成同一句「加载失败」就分不出来了。实测这条 CDN 在受限网络下会间歇性超时。
     */
    sdkLoadFailed: '认证组件加载失败。请检查网络后重试；如反复失败，可能是网络限制了外部认证服务，请联系客服。',
    /** 脚本下来了但起不来：不是客户能自助解决的，直接引导找客服 */
    sdkBroken: '认证组件无法启动，请联系客服协助处理。',
  },

  /** 「用手机继续」二维码 */
  kycQr: {
    title: '扫码用手机认证',
    desc: '请 {name} 用手机扫描下方二维码，按提示完成认证。',
    scanHint: '用手机相机扫描即可打开，无需注册账号。',
    /* 别写「旧链接随即失效」：后端 issue() 不作废旧 token，刚发出去的那封邮件里的链接照样能用 */
    expire: '本二维码为该人员专属，可重复扫描，7 天内有效。',
    linkLabel: '或复制链接发送给本人',
    refresh: '重新生成',
    review: '已提交，正在审核中。审核完成后本页会自动更新。',
    resubmit: '需要重新拍摄证件。请按手机上的提示重新提交。',
    passed: '认证已通过',
    passedHint: '{name} 的身份认证已完成。',
    reverifyPassed: '新证件已通过认证',
    reverifyPassedHint: '{name} 的新证件已通过，资料更正经审核后生效。',
    reverifyRejected: '{name} 的新证件未能通过认证，请联系客服 {email}。',
    expired: '这条链接已失效，请点「重新生成」获取新的二维码。',
  },

  /** 认证链接落地页（免登录） */
  kycInvite: {
    /* 二期 P05：已通过的人被要求用新证件重新认证 */
    reverifyDesc: '{company} 正在更新您的身份资料，需要您用新证件完成身份认证。整个过程约需 3 分钟，无需注册账号。',
    reverifyWarn: '请准备好新的身份证件（不要用旧证件）并确保光线充足。',
    title: '完成身份认证',
    desc: '{company} 正在开立交易账户，需要您完成一次身份认证。整个过程约需 3 分钟，无需注册账号。',
    role: '角色',
    company: '所属公司',
    warn: '请准备好您的身份证件并确保光线充足。资料与证件不一致会转为人工审核并延长处理时间。',
    review: '已提交，正在审核中。您可以关闭此页面，结果会通知到公司的授权代表。',
    resubmit: '需要重新拍摄证件，请按页面提示重新提交。',
    /* 重新打开链接时的「审核中」整卡：与上面那句 review 不是一件事——那句是刚拍完停在本页时的提示 */
    reviewTitle: '资料审核中',
    reviewDesc: '您已经提交过一次认证，我们正在人工核对，暂时不需要重复提交。结果会通知到 {company} 的授权代表。',
    doneTitle: '认证已完成',
    doneDesc: '感谢您的配合。结果会通知到 {company} 的授权代表，您无需再做任何操作。',
    /* 终态（未通过 / 已移除）：不披露原因——这一页凭一条 token 就能打开 */
    endedTitle: '本次认证已结束',
    endedDesc: '这条链接对应的认证已经结束，暂时无法继续。请联系 {company} 的授权代表了解后续安排。',
    expiredTitle: '链接无效或已过期',
    expiredDesc: '认证链接的有效期是 7 天。请联系向您发送链接的公司授权代表重新发送一份。',
    contact: '如有疑问，也可以联系我们的客服：',
  },

  /** MT5 开通等待（V1.4 §5.5） */
  mt5Wait: {
    openingTitle: '交易账户开通中',
    openingDesc: '您的资料已全部通过，我们正在为您开立 MT5 交易账户。完成后会立即以邮件通知您。',
    openingBanner: '交易账户正在开通中，完成后我们会立即邮件通知您。',
    // failedTitle / failedDesc / lockedNote / refresh 随 Mt5WaitView 一起删：说明页已无入口，弹窗版文案在下面
    // 首页横幅 + 说明弹窗标题（用户 09-20 口径）
    banner: '您的 MT5 交易账户暂未能开通',
    failedDialogBody: '您的开户步骤已全部完成，但交易账户未能自动开立。我们已收到该问题，请联系客服协助处理，我们会为您完成开通。',
    // 开通中：侧栏 / 能力不足的点击弹这个（用户 09-20 口径）
    openingDialogTitle: '您的交易账户正在开通中',
    openingDialogBody: '您的开户步骤已全部完成。开通通常几分钟内完成，账户就绪后我们会将 MT5 登录信息发送至您的邮箱；如 1 个工作日内仍未收到，请联系客服。',
  },

  /** 公司信息（V1.4 §6B） */
  company: {
    peopleHint: '以下每位人员均须各自完成 Sumsub 身份认证（证件 + 活体检测 + 地址证明）；标签为该人的身份认证结果。',
    title: '公司信息',
    entityTitle: '公司主体',
    legalName: '公司法定名称',
    acn: 'ACN',
    incorporation: '成立日期',
    address: '注册办公地址',
    classification: '客户分类',
    peopleTitle: '授权代表与公司相关人士',
    kycState: '身份认证：{state}',
    gotoPeople: '前往身份认证清单 ›',
    noPeople: '暂无相关人士记录。',
    // 原型 V1.4.1 说明条口径
    // 邮箱走 {email} 占位（useSupport().email 唯一来源），语言包不再写死地址
    readOnlyNote: '法律实体名称、ACN、董事与受益人、授权代表等关键信息如需变更，请联系客服 {email} 并提供相应的 ASIC 变更文件。开户时提交的申请文件由我方按记录保留政策归档，如需副本请联系客服。',
  },

  pwd: {
    // §5.3 登录密码有效期与到期提醒。一律表述为「我们的账户政策」
    rowLabel: '登录密码',
    lastChanged: '上次修改 {date}',
    daysLeft: '剩余 {n} 天到期',
    expired: '已过期，需立即修改',
    bannerText: '根据我们的账户政策，用户中心登录密码每 90 天需更新一次。您的密码将在 {n} 天后到期，请及时修改。',
    bannerAction: '修改密码',
    forceTitle: '请更新登录密码后继续',
    forceDesc: '根据我们的账户政策，用户中心登录密码每 90 天需更新一次。您的密码已到期，请设置新密码后继续使用。（此密码与 MT5 交易密码不同。）',
    modalTitle: '登录密码即将到期',
  },

  overview: {
    accountIdOpening: '—（开通中，稍后分配）',
    tagOpening: '开通中',
    tagMt5Failed: '暂未能开通',
    bannerOnboardCorp: '还需 {n} 人完成身份认证，全部通过后我们会自动为公司开立交易账户。',
    corpTask: '完成身份认证',
    corpTaskDesc: '公司的授权代表、董事与最终受益人都要各自完成一次身份认证。',
    corpTaskLink: '查看认证清单 ›',
    corpTaskFoot: '全部人员通过认证并开立 MT5 账户后，即可使用资金管理、报表与平台下载。',
    corpTaskCta: '查看认证清单',
    greeting: '你好，{name}',
    emailLine: '邮箱：{email}',

    // §6.1.2 待开户任务弹窗
    tasksTitle: '完成开户的最后步骤',
    task1: 'CFD 知识测试',
    task1Desc: '10 道题，答对 8 道及以上即通过',
    task2: '身份认证',
    task2Desc: '上传证件并完成人脸识别，系统自动审核',
    // 审核中（自动审核 / 转人工）替换掉上面那句「上传证件…」——资料已经交了，再让他看怎么交是误导（用户 09-20）
    task2Reviewing: '已提交，我们正在人工核对（通常 1 个工作日内），您无需重新提交。',
    // 需补件（最新 KYC 记录 RED、进度仍待开户）：标签 / 说明 / 按钮 / 首页横幅（用户 09-20）
    taskResubmit: '需补件',
    task2Resubmit: '证件未能通过审核，请重新拍摄并提交；其余资料已保存。',
    startKycResubmit: '重新拍摄证件',
    bannerResubmit: '您的身份证件未能通过审核，请重新拍摄并提交',
    task2Locked: '请先通过知识测试',
    // 公司户免测（接口 0.8.0 exempt）
    taskExempt: '公司户免测',
    task1Exempt: '公司账户无需知识测试，由授权代表直接完成身份认证',
    /*
     * 别写成「只需授权代表完成身份认证」：MT5 的门槛是**全员通过**（现任授权代表 + 全部董事 / UBO），
     * 而且这句话就摆在下面那张写着「已通过 1 / 3」的任务卡上方，自己打自己。
     * 公司户与零售的区别是免知识测试与免适当性问卷，不是「只认代表一个人」。
     */
    tasksDescCorporate: '公司账户无需知识测试，只要全部公司相关人士完成身份认证，我们就会自动为您开立 MT5 真实交易账户。',
    taskTodo: '待完成',
    taskDoing: '进行中',
    taskReviewing: '审核中',
    taskDone: '已完成',
    startQuiz: '开始知识测试',
    startKyc: '继续身份验证',
    ctaFinish: '完成最后步骤以开通账户',
    // 账户配置中（接口 0.8.4 accountProvisioning）
    tagProvisioning: '账户配置中',
    tasksDescProvisioning: '两项任务均已完成，我们正在为您开立 MT5 真实交易账户，完成后会立即以邮件通知您。',
    tasksDescOpenFailed: '很抱歉，您的交易账户未能开立。如需了解详情，请联系客服 {email}。',
    bannerOpenFailed: '很抱歉，您的交易账户未能开立，请联系客服了解详情',

    // §6.1.1 待提交引导弹窗
    applyTitle: '请先完成开户申请',
    applyDesc: '该功能需在开户完成后使用。您的开户申请尚未提交，请从中断处继续填写并提交。',
    applyProgress: '开户申请进度：已完成 {done}/5 步 · 当前进行到 第 {step} 步 · {name}',
    applyStep1: '提交开户申请',
    applyStep2: '完成 CFD 知识测试与身份认证',
    applyStep3: '系统自动为您开立 MT5 真实交易账户',
    continueApply: '继续开户',
    bannerDraft: '您有一份未完成的开户申请',
    // 粗标题后的进度句（原型横幅口径）；步名 {name} 是后端渲染的展示字符串，不翻译
    bannerDraftDesc: '已完成 {done}/5 步，当前进行到「{step}. {name}」。此前填写的信息已保存，可直接继续。',
    tagDrafting: '申请填写中',

    // 账户卡
    cfdAccount: 'CFD 账户',
    accountIdPending: '—（成功开户后分配）',
    fundsLabel: '资金',
    marginLabel: '保证金',
    availableLabel: '可用',
    plLabel: '盈亏',
    balance: '余额',
    equity: '净值',
    floatingPl: '浮动盈亏',
    freeMargin: '可用保证金',
    marginLevel: '保证金水平',
    accountNote: '以上数据为所选交易账户 {login}（{type}）。',
    leverageNote: '负余额保护已启用',
    // 概览对齐原型 v-dash
    balanceOf: '余额（{cur}）',
    tileDepositDesc: '银行转账（AUD / USD）',
    tileWithdrawDesc: '转账至您本人已审核的银行账户',
    acctMeta: '账户 ID：{login} · 币种 {currency}',
    accountDetails: '账户详情',
    colTime: '时间',
    colType: '类型',
    colMethod: '方式',
    colCurrency: '币种',
    colAmount: '金额',
    colStatus: '状态',

    bannerOnboard: '完成您的开户',
    // §7 受限模式首页横幅（按模式分文案；按钮弹对应说明弹窗）
    bannerSuit1: '暂未通过适应性评估。您可于 {date} 后重新申请，到期我们会邮件提醒您。',
    bannerKtCooling: '知识测试未通过，可于 {date} 后重考（届时邮件提醒您）。',
    bannerKtReady: '知识测试的等待期已结束，现在可以重新参加测试。',
    bannerDup: '您的开户申请正在人工审核中，暂时无法继续开户流程。',
    bannerTerminal: '很抱歉，您暂不符合我们的开户条件。如有疑问请联系客服。',
    // SUIT2 专句（产品 09-20）
    bannerTerminalSuit2: '根据目标市场确定（TMD）评估，我们无法为您开立账户。如有疑问请联系客服。',
    // AGE 专句（产品 09-20）
    bannerTerminalAge: '很抱歉，您的申请未能通过。',
    viewDetails: '查看说明',
    // §9 最近记录（最近出入金摘要；交易记录待二期报表接口）
    recentTitle: '最近记录',
    recentEmpty: '暂无出入金记录。',
    recentViewAll: '查看全部报表 ›',
    typeDeposit: '入金',
    typeWithdraw: '出金',
    // §6.4 开通失败兜底：开户已完成但账户尚未出现
    provisioningBanner: '您的资料已全部通过，交易账户正在配置中，完成后我们会立即邮件通知您。',
    bannerMore: '＋ 还有 {n} 项待处理',
    bannerCollapse: '收起',

    quickDeposit: '入金',
    quickWithdraw: '出金',

    staleData: '数据更新于 {time}',
    // 批量取数时单个账户失败：必须说'取不到'，不能显示成 0（0 会被当成真的没钱）
    fundsUnavailable: '该账户的资金数据暂时无法获取，请稍后刷新。',
    noAccountYet: '暂无账户',
  },

  restricted: {
    // §7 受限模式：所有拒绝 / 审核弹窗仅含「联系客服 + 确定」
    // 原型 V1.4.1 弹窗口径（用户 09-20）；日期取接口 suitabilityCooldownUntil
    suit1Title: '暂未通过适应性评估',
    suit1Body: '根据您的作答情况，您暂不符合我们 CFD 产品的目标市场确定（TMD）要求。您的申请已暂停，可于 {date} 后重新申请；到期我们会通过邮件提醒您。',
    reapply: '重新申请',
    reapplied: '已为您重新开启申请',
    // 非终态的兜底：门禁漏判 / 状态不同步时，绝不能对正常客户说「不符合开户条件」
    unavailableTitle: '该功能当前不可用',
    unavailableBody: '请稍后重试。如有疑问，请联系客服 {email}。',
    terminalTitle: '很抱歉，您暂不符合我们的开户条件',
    terminalBody: '如需了解更多或办理账户关闭，请联系客服 {email}。',
    // SUIT2 专句（产品 09-20）
    suit2Title: '我们无法为您开立账户',
    suit2Body: '很抱歉，根据目标市场确定（TMD）评估，我们无法为您开立账户。该结果为最终结论，不再提供重新申请。如有疑问请联系客服；如需关闭账户，请联系客服办理。',
    // AGE 专句（产品 09-20）
    ageTitle: '很抱歉，您的申请未能通过',
    ageBody: '很抱歉，您的申请暂未符合我们的开户要求。如您认为这是误判或需要了解更多信息，请联系我们的客服团队。',
    // 查重核实中（DUP，0.13.5 起可登录；D-96）：中性「审核中」，不是终态
    dupTitle: '您的开户申请正在审核中',
    dupBody: '我们已收到您的开户申请，目前正在人工审核。审核期间暂时无法继续开户流程，账户资料可正常查看。审核完成后我们会通过邮件通知您；如需了解进度，请联系客服 {email}。',
    kt1Title: '知识测试冷却中',
    // 产品 09-20 给的口径；等待时长按次数分两句（第 1 次 48 小时 / 第 2 次 6 个月），具体日期取接口 nextAvailableAt
    kt1Body: '您的知识测试未达到通过线（80%）。为了让您有时间复习相关材料，48 小时后方可重考（{date} 之后）；冷却结束我们会通过邮件提醒您，届时从「完成开户的最后步骤」即可再次进入测试。',
    kt2Body: '您的知识测试未达到通过线（80%）。为了让您有时间复习相关材料，6 个月后方可重考（{date} 之后）；冷却结束我们会通过邮件提醒您，届时从「完成开户的最后步骤」即可再次进入测试。',
    ktBlockedTitle: '知识测试次数已用完',
    readOnlyNote: '当前账户为只读状态，资料修改请联系客服。',
  },

  quiz: {
    title: 'CFD 知识测试',
    // 公司户免测进场页（接口 0.8.0 exempt）
    exemptTitle: '公司账户无需进行知识测试',
    exemptBody: '知识测试仅面向个人客户。请授权代表直接完成身份认证，通过后我们会自动开立 MT5 真实交易账户。',
    // 进场页仅展示两条规则（§6.2）
    ruleQuestions: '共 10 道题，答对 8 道及以上（80%）即通过',
    ruleCooldown: '共有 3 次机会：第 1 次未通过需等待 48 小时，第 2 次未通过需等待 6 个月，第 3 次未通过将无法继续开户。',
    attemptNotice: '这是您的第 {n} 次测试机会（共 {max} 次）。',
    start: '开始测试',
    resume: '继续上次的测试',
    progress: '第 {cur} / {total} 题',
    submit: '提交答卷',
    submitConfirmTitle: '提交答卷',
    submitConfirm: '提交后不可更改，确定提交吗？',
    unanswered: '还有 {n} 道题未作答',
    passedScore: '通过（{score}/10）',
    passedNext: '接下来完成身份认证，即可开立交易账户。',
    continueKyc: '继续身份验证',
    // 失败不显示错题与正确答案（§6.2）
    failedTitle: '未达到通过线',
    failedRetryAt: '您可于 {date} 之后重新测试。',
    failedFinalTitle: '很抱歉，您暂不符合我们的开户条件',
    failedFinalBody: '本次为第 3 次未通过，我们无法继续为您办理开户。',
    mailSent: '结果与说明已发送至您的邮箱。',
    coolingUntil: '可于 {date} 后重新测试',
    noAttemptsLeft: '次数已用完',
    alreadyPassed: '您已通过知识测试',
    resumeHint: '已为您恢复上次的答题进度。',
    answerFailed: '答案未能保存，请重新选择。',
  },

  /** 敏感信息更正的重新认证进度卡（预检页 / 认证页 / 免登录页共用，2026-10-15；进度由后端给，不向客户透露识别值不一致） */
  reverifyCard: {
    submittedTitle: '新证件已提交，正在审核',
    submittedDesc: '我们正在审核您的新证件。资料更正处理完成后会以邮件通知您，您可以先离开本页。',
    submittedDescInvite: '感谢您用新证件完成认证，我们正在审核；{company} 的授权代表会收到结果。您可以关闭本页。',
    passedTitle: '新证件已通过认证',
    passedDesc: '资料更正经审核后生效，届时会以邮件通知您。',
    passedDescInvite: '资料更正经审核后生效，{company} 的授权代表会收到通知。您可以关闭本页。',
    retryTitle: '新证件未能通过认证',
    retryDesc: '请检查证件后重新拍摄上传；如仍无法通过，请联系客服 {email}。',
    rejectedTitle: '新证件未能通过认证',
    rejectedDesc: '请联系客服 {email}，我们会协助您处理。',
    submittedNow: '新证件已提交，我们正在审核。您可以关闭本页。',
    // 恢复登录时客服要求重新提交（决策 029，D-98）：交完、等结论。文案待产品确认
    rekycSubmittedTitle: '资料已提交，正在审核',
    rekycSubmittedDesc: '我们正在审核您按客服要求重新提交的资料，您可以先离开本页。',
  },

  kyc: {
    /* 二期 P05：敏感信息更正发起的重新认证——进度由后端给（reverifyCard），这里只留「待认证」那一档的说明 */
    reverifyIntro: '我们正按您的要求更新身份资料，请用新的证件完成身份认证。',
    /* 证件临期 / 已过期的重新认证（认证页 ?renew=1）：不出开户完成页 */
    renewIntro: '您的证件即将到期或已过期，请用有效证件重新完成身份认证。',
    renewPassedTitle: '证件已更新',
    renewPassedDesc: '您已用有效证件完成认证，证件有效期会随之更新。',
    // 恢复登录时客服要求重新提交（决策 029，D-98）：认证页待认证时的说明、出了结论（要求已清掉）后的结果页。文案待产品确认
    rekycIntro: '客服已要求您重新提交认证资料，请按指引完成身份认证。',
    rekycPassedTitle: '认证已完成',
    rekycPassedDesc: '您按客服要求重新提交的资料已通过认证。',
    resubmitTitle: '请重新拍摄证件',
    resubmitBody: '我们收到了您的资料，但需要您重新提交一次。请按下方提示重新拍摄证件，注意光线充足、四角完整、避免反光。',
    title: '身份认证',
    intro: '请准备好您的身份证件。整个过程约 3 分钟，由我们的认证服务商完成采集与自动审核。',
    startBtn: '开始认证',
    mobileTitle: '用手机继续',
    mobileHint: '在手机上打开本页即可用手机摄像头完成拍摄，网页端会实时同步进度。',
    // §6.3 各状态页面表现
    reviewing: '资料已提交，正在自动审核（通常几分钟）',
    reviewingHint: '您可以停留等待，也可以先离开。结果会以邮件通知您。',
    manual: '正在人工审核',
    manualHint: '我们正在进一步核实您的资料，结果将以邮件通知。',
    passed: '身份认证已通过',
    passedNext: '我们正在为您开立 MT5 真实交易账户。',
    rejected: '很抱歉，本次认证未能通过',
    // 硬拒绝统一婉拒，不披露原因（§6.3）
    rejectedBody: '如需了解更多，请联系客服 {email}。',
    resubmit: '重新拍摄',
    // kyc/token 恒返回 50311 的降级态
    channelDownTitle: '认证通道准备中',
    channelDownBody: '身份认证服务正在配置中，暂时无法开始。我们会在开通后以邮件通知您，您也可以稍后回来重试。',
    quizFirst: '请先通过 CFD 知识测试',
    docExpiry: '证件有效期',
  },

  onboardDone: {
    currencyNote: '（按您申请时的选择）',
    nbpValue: '已启用 — 您的亏损不会超过账户内资金',
    riskWarn: 'CFD 为复杂的高风险杠杆产品，您可能迅速产生亏损；请仅在充分理解相关风险后进行交易。',
    title: '开户完成',
    desc: '您的 MT5 真实交易账户已开立，可以开始入金交易。',
    login: 'MT5 账号',
    server: '服务器',
    nbp: '负余额保护已启用',
    mailSent: '开户完成邮件已发送，内含 MT5 登录信息。',
    firstDeposit: '立即入金',
    // MT5 接口异常时的兜底（§6.4）
    provisioning: '账户配置中，完成后邮件通知',
    provisioningHint: '您的资料已全部通过，我们正在开立交易账户。完成后会立即以邮件通知您。',
    // KYC 通过但账户还没开出来：不能说「开户完成」
    kycPassedTitle: '身份认证已通过',
    kycPassedDesc: '您的资料已全部通过审核，交易账户开立中。',
    // CRM 人工确认不开（accountOpening=FAILED）：中性说明，不披露原因
    openFailedTitle: '账户未能开立',
    openFailedDesc: '很抱歉，您的交易账户未能开立。如需了解详情，请联系客服 {email}。',
  },

  // 接口 7.0：MT5 交易密码重置（邮件链接落地页 /mt5-password/reset）
  mt5pwd: {
    resetTitle: '设置新的 MT5 交易密码',
    resetDesc: '此密码用于登录 MT5 交易终端，与用户中心登录密码无关；设置后不会退出用户中心。',
    newPassword: '新交易密码',
    ruleLength: '8–15 位',
    // @ 必须写成 {'@'} 字面量：vue-i18n 把裸 @ 当链接消息（@:key）的起头，整条消息编译失败，
    // 抛在 PasswordRuleHint 的渲染里、把整块规则说明弄没了（2026-09-16 上过一次 dev）。同 readOnlyNote 的邮箱写法
    ruleSymbol: '至少 1 个符号（如 # {\x27@\x27} !）',
    // MT5 只收 ASCII 可打印字符（后端 Mt5PasswordRules.isAsciiPrintable）：中文、全角符号、空格都不行
    ruleAscii: '仅限英文字母、数字与键盘符号，不含空格',
    done: '新交易密码已生效',
    doneDesc: '确认邮件已发送。请使用新密码登录 MT5 交易终端。',
    backToPortal: '返回用户中心',
    linkExpiredDesc: '重置链接仅 30 分钟内有效且只能使用一次。请登录用户中心，在「我的账户」重新发起。',
    // 50311：结果未确认、链接不放回——不给重试按钮
    unknownTitle: '重置结果暂未确认',
    unknownDesc: '您的交易密码可能已经更新。请先用新密码尝试登录 MT5 交易终端；若无法登录，请在「我的账户」重新发起一次重置。为避免混淆，本链接不再可用。',
    goMyAccount: '前往我的账户',
  },

  account: {
    accountName: '账户名称',
    corpTypeSuffix: '（公司客户 Wholesale）',
    sophCorpTypeSuffix: '（公司客户 Sophisticated）',
    // 杠杆按品种类别不同（业务 CP-002）：不再显示账户级 1:30，给官网杠杆表外链
    leverageByProduct: '按品种类别不同',
    leverageTable: '查看杠杆表',
    // 形态按原型 V1.4.1 #v-myaccount：面包屑 / 副标题 / 查看账户下拉 / 四张统计卡 / 账户详情表
    pickAccount: '查看交易账户',
    detailsTitle: '账户详情',
    mt5Login: 'MT5 账号',
    retailTypeSuffix: '（零售 Retail）',
    sophIndTypeSuffix: '（个人 Sophisticated）',
    baseCurrency: '基础货币',
    currency: '货币',
    nbp: '负余额保护',
    nbpOn: '已启用',
    nbpNotApplicable: '不适用',
    nbpNote: '负余额保护：您的账户亏损不会超过账户余额。',  // 开户完成页 §6.4 仍在用
    title: '我的账户',
    server: '服务器',
    type: '账户类型',
    leverage: '杠杆',
    marginWarn: '{type} · {login}　保证金水平 {level}，已触及 {line} 追加保证金水平（PDS）',
    marginDanger: '{type} · {login}　保证金水平 {level}，已触及 {line} 强平水平，持仓可能被自动平仓',
    depositNow: '立即入金',
    frozenNote: '该账户当前已冻结，临时禁止交易：不能开仓也不能平仓、暂不能入金，仍可出金与查看报表。',
    disabledNote: '该账户已停用，如需恢复请联系客服。',
    closedNote: '该账户已关闭。',
    changingNote: '账户变更处理中，请稍后刷新查看。',
    pendingNote: '账户待启用，我们正在完成配置。',
    footerNote: '各账户按其自身币种独立计价，账户之间资金不互通。如需开立新交易账户，请联系客服。',
    // 接口 7.0：重置 MT5 交易密码（只发链接，落地页自设）
    resetMt5Pwd: '重置 MT5 密码',
    resetMt5PwdTitle: '重置 MT5 交易密码',
    resetMt5PwdDesc: '我们将向您的注册邮箱发送一封重置链接（30 分钟内有效，仅可使用一次），请在邮件中设置新的交易密码。重置的是 MT5 交易密码，不影响用户中心登录密码，也不会退出当前登录。',
    resetMt5PwdSend: '发送重置链接',
    resetMt5PwdSent: '重置链接已发往 {email}，请查收邮件。',
    resetMt5PwdUnavailable: '当前账户状态不支持重置交易密码。',
    // 原型 v-myaccount「开户日期」= MT5 开户成功时点（AccountRow.openedTime， 定稿、待后端部署）
    openedTime: '开户日期',
    // 模拟账户在这一页只读展示（不参与当前账户/出入金/预警，R-15）
  },

  profile: {
    dob: '出生日期',
    amlScreening: 'AML 筛查',
    taxResidency: '税务居民身份',
    // 原型写「TFN 已提供」；我们只在境外纳税时收 TIN，澳洲税务居民没有 TFN 字段
    tinProvided: 'TIN 已提供',
    // 客户答过「境外纳税＝是」但没填国家时的兜底：不猜澳大利亚
    taxCountryUnknown: '国家/地区未填写',
    lastLogin: '最近登录',
    amlPassed: '已通过',
    corpNote: '本页显示的是您本人的认证与文件。公司主体资料与其他相关人士的认证状态请见：',
    corpLinkCompany: '公司信息',
    corpLinkPeople: '人员认证与文件',
    title: '个人资料',
    keyInfoNote: '如需更正姓名、出生日期等关键信息，请联系客服并提供证明文件。',
    commTitle: '通讯偏好',
    basicTitle: '基本信息',
    openedTime: '开通时间',
    fullName: '姓名',
    email: '邮箱',
    phone: '手机号',
    address: '居住地址',
    // 接口 7.0：通知语言（只影响我们发给客户的邮件；界面语言用顶栏切换，两者解耦）
    notifyLocale: '通知语言',
    notifyLocaleHint: '仅影响我们发送给您的邮件所使用的语言。界面语言请使用右上角的语言切换。',
    notifyLocaleSaved: '通知语言已更新。',
    // 语言名按各自文字写，三种界面下都一样（2026-10-12 加繁体）
    localeZh: '简体中文',
    localeZhHk: '繁體中文',
    localeEn: 'English',
    // 姓名 / 邮箱 / 手机修改一律走客服（§14.2）
    contactCsToChange: '联系客服修改',
    contactCsHintEmail: '修改邮箱地址需要我们核验您的身份并审批变更。请联系客服 {email}。',
    contactCsHintPhone: '修改手机号需要我们核验您的身份并审批变更。请联系客服 {email}。',
    contactCsHintAddress: '修改居住地址需要我们核验新地址证明并审批变更。请联系客服 {email}。',

    docTitle: '认证与文件',
    idProof: '身份证明',
    addressProof: '地址证明',
    verified: '已验证',
    notVerified: '未验证',
    docExpiryOn: '证件有效期 {date}',
    reverify: '立即认证',
    // 表述为「我们的账户政策」，不得写监管要求（§3）
    docPolicyNote: '我们会不定期请您更新资料，以保持账户信息准确，包括在身份证件到期前完成更新，以及每两年提供一次新的地址证明。',

    securityTitle: '安全',
    closeAccountTitle: '关闭账户',
    closeAccountNote: '如需关闭账户，请联系客服 {email}。办理前需满足：所有持仓已平仓、账户余额为零，且没有正在处理的存取款。',
  },

  /* 补填手机号弹窗（D-98，cfd-platform 决策 029）：恢复登录时手机号被清空的客户，登录后先补填。文案待产品确认 */
  phoneFill: {
    title: '请补填手机号',
    desc: '为保障账户安全，请填写您本人在用的手机号后继续使用用户中心。',
    numberLabel: '手机号码',
    codeLabel: '国际区号',
    // 与开户站 s3a 同句（web-onboarding errors.phoneAu）
    invalidAu: '请输入有效的澳洲电话号码：10 位数字，以 02、03、04、07 或 08 开头。',
    invalid: '请输入有效的手机号码：4–20 位数字。',
    saved: '手机号已更新',
  },

  bank: {
    bankCountry: '银行所在国家',
    bankCountryHint: '非澳洲银行请填两位国家代码（如 NZ）；澳洲银行可留空。',
    // UAT CP-015：境外电汇需要收款行地址，必填
    bankAddress: '银行地址',
    bankAddressHint: '请填写开户行的完整地址（街道、城市、国家），国际转账需要。',
    bankAddressRequired: '请填写银行地址',
    swiftHint: '国际转账时填写，选填。',
    currencyHint: '须与该银行账户的实际开户币种一致；不一致会导致出金被银行退回。',
    presetTag: '开户时登记',
    presetNote: '开户时登记',
    // 需求 §12：审核中的账号显示提案号与提交日期（BankAccountView.proposalNo / submittedTime， 定稿、待后端部署）
    proposalNo: '提案号',
    submittedTime: '提交于',
    presetChange: '变更请联系客服',
    presetChangeTitle: '变更银行账户',
    presetChangeBody: '该账户是开户时随申请资料一并登记的，属于开户档案的一部分。如需变更，请联系客服办理，我们会核对资料后为您更新。',
    title: '银行账号',
    add: '添加银行账号',
    listEmpty: '您还没有添加银行账号，请点击「+ 添加银行账号」开始。付款须来自 ZR Markets 账户持有人本人名下、已核验的银行账户，我们不接受第三方付款。',
    bankName: '银行名称',
    holderName: '账户名称',
    bsb: 'BSB',
    accountNo: '账号',
    accountTail: '账号后四位',
    swift: 'SWIFT',
    currency: '账户币种',
    statement: '银行对账单',
    statementHint: '请上传近 12 个月内的银行对账单，用于证明账户归属。',
    statementRequired: '请上传银行对账单',
    // 42215（对账单 ref 失效）直接显示后端 message，这里不再有 statementInvalid
    pendingReview: '审核中',
    approved: '已审核',
    rejected: '已拒绝',
    submitted: '已提交审核，通过后即可用于出金。',
    // §12 校验
    holderMustMatch: '账户持有人须与开户姓名「{name}」完全一致。按我们的反洗钱政策，仅接受本人名下账户。',
    bsbInvalid: 'BSB 须为 6 位数字',
    accountNoInvalid: '请填写账号',
    onePendingOnly: '您已有一张银行账号在审核中，请等待审核结果后再提交。',
    thirdPartyNote: '付款须来自 ZR Markets 账户持有人本人名下、已核验的银行账户。我们不接受第三方付款。',
  },

  upload: {
    choose: '选择文件',
    uploading: '上传中…',
    remove: '移除',
    limits: '支持 PDF / JPG / PNG，单个文件不超过 10MB。',
    // 这两句只用于发请求前的本地预检；服务端拒绝（41311 / 42213 / 42214 / 50312）直接显示后端 message
    tooLarge: '文件超过 10MB，请压缩后再上传。',
    badType: '仅支持 PDF、JPG、PNG 格式。',
    notFound: '文件不存在或已失效，请重新上传。',
  },

  /**
   * 资金三页共用的文案（接口 4.0 交付 /api/c/funding/** 后新增）。
   *
   * ⚠️ §3 文案红线：**不得出现「免费 / 零手续费 / no fee」**。
   * 一期入金出金都不收费，做法是**整页不设手续费栏位**，
   * 而不是写一句「本次不收取手续费」——那同样构成诱导表述。
   */
  funding: {
    account: '交易账户',
    proposalNo: '申请编号',
    viewRecords: '查看记录',
    availableLabel: '可用',
    noAccount: '您当前没有可用于资金操作的交易账户。如需协助，请联系客服。',
    // 冻结账户的资金方向由后端裁决，前端不写死（见 dicts.ts MT5_ABILITY）
    frozenMayReject: '该账户目前已冻结、禁止交易，本次申请可能不被受理，以提交结果为准。',
    noRate: '该币种方向暂无可用汇率，暂时无法提交跨币种申请。',
    voucherInvalid: '汇款水单无效或已失效，请重新上传。',
  },

  deposit: {
    addBank: '+ 添加银行账户',
    title: '入金',
    // §10.1：附言账号随所选账户变化，是后台核账归属的关键
    remarkHint: '转账附言请填写您的 MT5 账号（{login}），以便我们快速核账入账。',
    currency: '存款币种',
    amount: '存款金额',
    amountPh: '请输入存款金额',
    remitDate: '汇款日期',
    remitDateHint: '选填。填写后有助于我们更快核对到账。',
    payer: '付款银行账户',
    payerHint: '仅可使用您本人已通过审核的银行账户付款。',
    noPayer: '您还没有已通过审核的银行账户，请先在「银行账号」中添加。',
    voucher: '汇款水单',
    voucherHint: '请上传本次汇款的银行回单或转账截图。',
    expected: '预计入账',
    // §10.1 跨币种引导句 + 即时汇率行（不带获取时间）
    fxLead: '所选账户（{login}）的账户货币为 {cur}，{from} 入金将按即时汇率自动兑换入账。',
    liveRate: '即时汇率 1 {from} = {rate} {to}',
    // §10.1 页面底部条款（澳洲版）—— 反洗钱表述为「我们的反洗钱政策」，不写监管要求
    termsTitle: '入金须知',
    terms1: '付款须来自 ZR Markets 账户持有人本人名下、已核验的银行账户。我们不接受第三方付款。',
    terms2: '款项到账并完成核账后，我们会存入您的交易账户，并通过邮件向您同步进度。',
    terms3: '提交存款通知即表示您确认资金来源合法，并已阅读 PDS、FSG 与《客户协议》。',
    terms4: '以其他币种存入的款项，将按处理您存款时适用的汇率转换，可能与页面显示的参考汇率不同。',
    receiving: '公司收款账户',
    receivingNote: '请使用您本人的银行账户，向下列账户汇款后再提交本页表单。',
    noReceiving: '当前币种暂无可用的收款账户，请联系客服。',
    bankTransfer: '银行转账',
    accountName: '账户名称',
    bankName: '银行名称',
    bankAddress: '银行地址',
    accountNo: '账号',
    submit: '提交存款通知',
    submitNote: '提交后我们会在收到款项并核对无误后为您入账，入账结果将以邮件通知。',
    submitted: '存款通知已提交',
    submittedNote: '我们会在核对到账后为您入账，处理进度可在存款记录中查看。',
    another: '再提交一笔',
  },

  withdraw: {
    // 形态按原型 V1.4.1：三张步骤卡 + 汇总卡 + 勾选确认；文案以需求 V1.4 §11 与原型为准
    title: '出金',
    stepAccount: '从哪个交易账户出金',
    stepAmount: '出金金额（{cur}）',
    stepBank: '收款银行账号',
    accountCurrency: '账户币种',
    // §11.2：出金页用「可提」，入金页与顶栏仍用「可用」
    withdrawableLabel: '可提',
    amount: '出金金额',
    fillMax: '全部提取',
    overLimit: '出金金额不能超过账户 {login} 的可提金额（{amount} {cur}）',
    availNote: '可提金额由系统按该账户的余额、净值与保证金占用计算。',
    unsettledNote: '另有 {amount} {cur} 近期入金尚在清算中，暂不可提取。',
    // §11.1 三重校验：无账号 → 引导添加；均审核中 → 展示审核中状态
    noBankTitle: '请先添加银行账号',
    noBankBody: '出金需转入您本人名下、已通过审核的银行账号。请先前往「资金管理 → 银行账号」添加并上传对账单。',
    goBank: '前往添加银行账号',
    bankPendingTitle: '银行账号审核中',
    bankPendingBody: '您的银行账号正在审核中，审核通过后即可发起出金（结果将邮件通知）。',
    holder: '账户名称',
    manageBanks: '管理',
    // 入账币种不再单独选，随所选收款账号联动（原型 V1.4.1）
    creditCurrency: '入账币种（银行账户币种）',
    creditFollows: '随所选收款银行账号联动',
    noSameCurrencyBank: '您没有 {cur} 币种的已审核银行账号，出金将按参考汇率换算入账。',
    refRate: '当前汇率（参考）',
    expected: '预计入账',
    expectedIn: '预计入账（{cur}）',
    transferNote: '仅转账至您本人名下账户，通常最多 5 个工作日到账。',
    // R-16：提交即扣款，勾选确认代替二次确认弹窗
    ack: '我了解提交后金额会立即从我的 MT5 账户扣除，且无法在用户中心撤销；若申请未获批准，资金将退回我的交易账户。',
    submit: '提交出金申请',
    // V1.4 §8.4：冻结账户允许出金，只提示其禁止入金
    frozenNote: '账户 {login} 当前已冻结，临时禁止交易：暂不能入金，但仍可正常提取该账户资金。',
    currencySwitched: '计价币种已切换为 {cur}',
    expectedEstimated: '预计入账（按提交时参考汇率估算）',
    // 后端 WithdrawResult.expectedAmount：参考值，执行汇率审批时才固化 —— 不能写「到账金额」
    expectedReference: '参考入账金额（以审批时执行汇率为准）',
    accountLine: '{login}（{type}）',
    submitted: '出金申请已提交',
    another: '再提交一笔',
    // 50321：扣款结果未知且未建单 —— 页面必须停住，且不给重试
    unknownTitle: '申请结果确认中',
    unknownNote: '本次提交的处理结果尚未确认，我们正在核对您账户的扣款状态。',
    unknownNoRetry: '请勿重复提交本次申请。请稍后在取款记录中查看结果，如有疑问请联系客服。',
  },

  records: {
    depositSettled: '存款记录',
    depositApplications: '入金申请记录',
    withdrawalSettled: '取款记录',
    withdrawalApplications: '出金申请记录',
    allAccounts: '全部账户',
    // §13：报表时间口径与站点其余位置不同，必须在表头注明；金额按记录所属交易账户的币种计价（§8.1，多账户下不是固定 AUD）
    mt5TimeNote: '下表时间均为 MT5 服务器时间（GMT+3）；金额以该笔记录所属交易账户的币种计价。',
    applyTime: '申请时间',
    // 6.0 补：到账时间 / 汇率 / 凭证
    settledTime: '到账时间',
    rate: '汇率',
    voucher: '凭证',
    export: '导出',
    viewVoucher: '查看',
    voucherOpenFailed: '凭证暂时无法打开，请稍后重试',
    // 6.0 补：申请时间范围筛选（§13 通用筛选条）
    rangeAll: '全部时间',
    range7d: '近 7 天',
    range30d: '近 30 天',
    range90d: '近 90 天',
    rangeYtd: '今年',
    // 列名按需求 §13 表 / 原型 V1.4.1
    proposalNo: '提案号',
    account: '交易账户',
    channel: '渠道',
    amount: '金额',
    settledAmount: '到账金额（账户币种）',
    expectedAmount: '预计到账（账户币种）',
    dealIdNote: 'MT5 Deal ID 为该笔出入金在 MT5 账户中的 balance 成交编号，可用于与交易平台对账。',
    dealId: 'MT5 Deal ID',
    status: '状态',
    empty: '暂无记录。',
    settledEmptyHint: '这里只显示已完成的记录；处理中的申请请看',
    // 申请页签「操作 · 重新发起」与表下「状态说明」（需求 §13 / §13.1；statusCode 由 定稿、待后端部署）。
    // 说明文案前端静态配，按 kind.CODE 取；措辞守 §3：不出现「监管要求」「免费」，退款口径与 R-16 披露句一致
    action: '操作',
    reinitiate: '重新发起',
    statusNotesTitle: '状态说明',
    statusHint: {
      deposit: {
        PROCESSING: '处理中：我们已收到您的存款通知，正在核对款项到账情况。',
        SETTLED: '已到账：款项已入账至您的 MT5 交易账户。',
        CANCELLED: '已取消：本次存款通知未完成处理。如您已完成汇款，请重新发起并上传汇款凭证。',
      },
      withdrawal: {
        REVIEWING: '审核中：金额已从您的 MT5 交易账户扣除，正在审核处理。',
        COMPLETED: '已完成：款项已付至您的收款银行账户。',
        REFUNDED: '已退回：本次申请未获通过，金额已退回您的 MT5 交易账户，您可重新发起。',
        REJECTED: '未成功：本次申请已取消或已超时，扣除的金额将退回您的 MT5 交易账户，您可重新发起。',
      },
    },
    pageInfo: '第 {page} / {max} 页，共 {total} 条',
    prev: '上一页',
    next: '下一页',
  },

  platform: {
    corpHolderNote: '账户持有人为 {company}，授权代表凭 MT5 账号与交易密码进行交易。',
    title: '平台下载',
    liveTag: 'Live',
    demoTag: 'Demo',
    liveTitle: '真实账户',
    demoTitle: '模拟账户',
    loginAccount: '登录账号',
    server: '服务器',
    password: '密码',
    passwordValue: '开户邮件中发送给您的 MT5 交易密码（与用户中心登录密码不同）',
    // 账户尚未开出来时替代空白的账号 / 币种两行
    noAccountYet: '交易账户还在开通中，账号与币种开通后会显示在这里。您现在就可以先下载并安装客户端，服务器名按下方填写即可。',
    // 纯下载态：这一页对拿不到账户的客户（申请被拒 / 查重 / 年龄或适当性未过 / 未提交）只留下载链接
    downloadOnlyNote: '您可以在这里下载 MetaTrader 5 客户端。登录账号与服务器信息会在交易账户开通后显示在本页。',
    demoPasswordNote: '模拟账户密码已在开通时发送至您的邮箱。',
    // 两个服务器名仅一词之差，不提示极易登错（§15）
    serverWarn: '真实账户与模拟账户位于不同服务器，登录时请选择与账号对应的服务器。',
    // §15 原文口径：7.0 起有了重置端点，文案改回指向「我的账户」（此前因无端点写成「联系客服」）
    notSameAsPortal: 'MT5 交易密码与用户中心登录密码不同。忘记可在「账户管理 → 我的账户 → 重置 MT5 密码」重新设置。',
    multiAccountNote: '当前显示交易账户 {login}（{type}）。您共有 {n} 个真实交易账户，可在顶栏切换账户查看对应的登录账号。',
    downloadTitle: '下载 MetaTrader 5',
    windows: 'Windows',
    macos: 'macOS',
    ios: 'iOS',
    android: 'Android',
    demoNotOpened: '模拟账户尚未开通',
  },

  support: {
    title: '帮助与支持',
    desc: '点击下方按钮会自动打开您设备上的邮件程序，向我们的客服团队发送邮件。',
    sendMail: '发送邮件给客服',
    subject: '客户咨询 — ZR 投资者门户',
    // 设备无默认邮件客户端时点击无反应，须同时给可复制的地址（§16）
    fallback: '如果点击后没有反应，说明您的设备未配置默认邮件程序。请手动发送邮件至：',
  },

  dict: {
    /** 公司相关人士角色（V1.4 §6A） */
    corpPersonRole: {
      AUTH_REP: '授权代表',
      DIRECTOR: '董事',
      UBO: '最终受益人',
    },
    /** 相关人士认证状态：开户前 6 态；REMOVED=已移除，不计入门槛 */
    corpPersonStatus: {
      TODO: '待认证',
      SENT: '已发送链接',
      REVIEW: '审核中',
      PASSED: '已通过',
      RESUBMIT: '需补件',
      FAILED: '未通过',
      REMOVED: '已移除',
    },
    /** 开户后的证件状态（5 态） */
    docState: {
      VALID: '有效',
      EXPIRING: '即将到期',
      EXPIRED: '已过期',
      // 原型口径是「审核中」：这一档既包括刚提交待出结果，也包括 Sumsub 判否后转人工，
      // 客户要看到的是「在我们手上」，而不是「你在重认」（他可能什么都没做）
      REVIEW: '审核中',
      // v1 迁移没带来有效期字段，待补录——不是「已过期」
      NOT_COLLECTED: '有效期待补录',
    },
    /** 证件类型（相关人士确认卡；未知值原样显示） */
    idType: {
      PASSPORT: '护照',
      DRIVER_LICENCE: '驾照',
      NATIONAL_ID: '身份证',
    },
    /** 客户分类（s761G） */
    clientClassification: {
      WHOLESALE_S761G: '公司客户 Wholesale（s761G）',
      SOPHISTICATED: '公司客户 Sophisticated',
    },
    mt5Status: {
      PENDING: '待启用',
      ENABLED: '正常',
      FROZEN: '已冻结·禁止交易',
      DISABLED: '已禁用',
      CLOSED: '已关闭',
      CHANGING: '变更中',
    },
    // 出入金渠道（接口 channel 字段，枚举码；未知值原样显示）
    channel: {
      BANK_TRANSFER: '银行转账',
      PAYID: 'PayID',
    },
    bankStatus: {
      PENDING_REVIEW: '审核中',
      APPROVED: '已审核',
      REJECTED: '已拒绝',
      REPLACED: '已替换',
    },
    // 客户可见的开户状态标签只有两种（§3 状态术语口径）
    facing: {
      IN_PROGRESS: '待完成开户',
      DECLINED: '开户未通过',
      DONE: '',
    },
  },

  footer: {
    // 官网英文原文，中文模式下不翻译（§3 页脚口径）
    entity: 'Zircon Financial Service (Australia) Pty Ltd',
    acn: 'ACN 672 642 054',
    afsl: 'AFSL 562700',
    // 业务 09-24：持牌主体行末尾加 trading as ZR Markets；页脚英文原文，中文模式同样不翻译
    tradingAs: 'trading as ZR Markets',
    risk: 'Trading in CFDs carries a high level of risk and may not be suitable for all investors. You may lose more than your initial investment. Please read our {pds}, {fsg} and {tmd} before deciding to trade.',
  },
}
